// @ts-nocheck
import {action, observable} from "mobx";
import {PersonProfile} from "../pages/MyTeam/MyTeamCard";

export type VacationRequestCreateType = 'my' | 'manager' | 'assistant'


export default class VacationRequestStore {
  type: VacationRequestCreateType | undefined;
  @observable
  selectedPersonPositionGroupId?: string;

  @action
  clear = () => {
    this.type = undefined;
  }

  @action
  setType = (type: VacationRequestCreateType) => {
    this.type = type;
  }
  @action
  setSelectedPersonPositionGroupId(positionGroupId?: string) {
    this.selectedPersonPositionGroupId = positionGroupId;
  }
}
